import { useState } from 'react'

const ONE_MINUTE = 60_000
const ONE_HOUR = 60 * ONE_MINUTE
const ONE_DAY = 24 * ONE_HOUR
const PREFIX = 'bb-'

function namespaceBillboardKey(name: string) {
  // Ideally we would namespace the billboard key, that way "clear all
  // billboards" can loop through local storage and delete any that start with
  // the namespace.
  return `${PREFIX}${name}`
}

export function isBillboardHidden(name: string) {
  const initialIsHidden = window.localStorage.getItem(
    namespaceBillboardKey(name),
  )

  if (!initialIsHidden) {
    return false
  }

  const diff =
    new Date().valueOf() - new Date(Number(initialIsHidden)).valueOf()

  return diff < 30 * ONE_DAY
}

export function hideBillboard(name: string) {
  window.localStorage.setItem(
    namespaceBillboardKey(name),
    String(new Date().valueOf()),
  )
}

export function clearBillboardHidden(name: string) {
  window.localStorage.removeItem(namespaceBillboardKey(name))
}

export function clearAllBillboardHidden() {
  for (const key in localStorage) {
    if (key.startsWith(PREFIX)) {
      localStorage.removeItem(key)
    }
  }
}

function useBillboardHiddenState(name: string) {
  // There's probably a bug here if the name changes.
  const [isHidden, setIsHidden] = useState(() => isBillboardHidden(name))

  return [
    isHidden,
    (value: boolean) => {
      setIsHidden(value)

      if (value) {
        hideBillboard(name)
      } else {
        clearBillboardHidden(name)
      }
    },
  ] as const
}

export default useBillboardHiddenState
